import { render, staticRenderFns } from "./Inventories.vue?vue&type=template&id=a0668a92&scoped=true&"
import script from "./Inventories.vue?vue&type=script&lang=js&"
export * from "./Inventories.vue?vue&type=script&lang=js&"
import style0 from "./Inventories.vue?vue&type=style&index=0&id=a0668a92&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0668a92",
  null
  
)

export default component.exports